require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-empathy-mapping.json") })
        }
      }, "path---workshops-empathy-mapping");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-empathy-mapping!./.cache/json/workshops-empathy-mapping.json
// module id = 498
// module chunks = 231608221292675